document.addEventListener('DOMContentLoaded', () => {
    const posterSelector = '.nt-poster img, .nt-card-pic img, .nt-event-poster img';
    const fallbackPoster = image => {
        if (!(image instanceof HTMLImageElement) || !image.matches(posterSelector) || image.dataset.ntFallback) return;
        image.dataset.ntFallback = 'true';
        image.closest('picture')?.querySelectorAll('source').forEach(source => source.remove());
        image.removeAttribute('srcset');
        image.src = '/skins/new_tuz/images/poster-placeholder.svg';
    };
    document.addEventListener('error', event => fallbackPoster(event.target), true);
    document.querySelectorAll(posterSelector).forEach(image => {
        if (image.complete && !image.naturalWidth) fallbackPoster(image);
    });
    const header = document.querySelector('.nt-header');
    const updateHeader = () => header?.classList.toggle('is-small', window.scrollY > 40);
    updateHeader();
    window.addEventListener('scroll', updateHeader, {passive:true});
    window.addEventListener('pageshow', updateHeader);
    const cities = document.querySelector('[data-nt-cities]');
    const closeCities = () => { if (cities) cities.open = false; };
    cities?.addEventListener('toggle', () => cities.querySelector('summary')?.setAttribute('aria-expanded', String(cities.open)));
    document.addEventListener('click', event => { if (!cities?.contains(event.target)) closeCities(); });
    cities?.addEventListener('keydown', event => { if (event.key === 'Escape') { closeCities(); cities.querySelector('summary')?.focus(); } });
    const menu = document.querySelector('#nt-menu');
    const menuButton = document.querySelector('[data-nt-menu]');
    const open = dialog => { if (dialog && !dialog.open) dialog.showModal(); };
    const close = dialog => { dialog?.close(); };
    menuButton?.addEventListener('click', () => { open(menu); menuButton.setAttribute('aria-expanded', 'true'); });
    menu?.querySelectorAll('a[href]').forEach(link => link.addEventListener('click', () => close(menu)));
    menu?.addEventListener('close', () => menuButton?.setAttribute('aria-expanded', 'false'));
    const mobileNavigation = window.matchMedia('(max-width: 1060px)');
    mobileNavigation.addEventListener('change', event => { closeCities(); if (!event.matches) close(menu); });
    document.querySelector('[data-nt-search]')?.addEventListener('click', () => open(document.querySelector('#nt-search')));
    document.querySelectorAll('.nt-dialog').forEach(dialog => {
        dialog.querySelector('[data-nt-close]')?.addEventListener('click', () => close(dialog));
        dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(dialog); } });
    });
    menu?.querySelectorAll('.loginOpenPopup').forEach(button => button.addEventListener('click', () => close(menu)));
    const stage = document.querySelector('.nt-stage');
    const slides = [...document.querySelectorAll('.nt-slide')];
    const dots = [...document.querySelectorAll('[data-nt-slide]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    const show = value => {
        index = (value + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === index); slide.inert = i !== index; });
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
    };
    const stop = () => clearInterval(timer);
    const start = () => { stop(); if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => show(index + 1), 7000); };
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
    stage.querySelector('[data-nt-prev]')?.addEventListener('click', () => { show(index - 1); start(); });
    stage.querySelector('[data-nt-next]')?.addEventListener('click', () => { show(index + 1); start(); });
    stage.addEventListener('mouseenter', stop); stage.addEventListener('mouseleave', start);
    stage.addEventListener('focusin', stop); stage.addEventListener('focusout', event => { if (!stage.contains(event.relatedTarget)) start(); });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    let touchX;
    stage.addEventListener('touchstart', event => { touchX = event.changedTouches[0].clientX; }, {passive:true});
    stage.addEventListener('touchend', event => { const delta = event.changedTouches[0].clientX - touchX; if (Math.abs(delta) > 50) { show(index + (delta < 0 ? 1 : -1)); start(); } }, {passive:true});
    show(0); start();
});

// Preserve the existing auth AJAX handlers while adding keyboard/focus behavior.
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.basket').forEach(link => link.addEventListener('click', event => {
        const count = parseInt(link.querySelector('.basket--counter span')?.textContent || '0', 10);
        if (!count) { event.preventDefault(); document.querySelector('#nt-empty-cart')?.showModal(); }
    }));
    const popups = [...document.querySelectorAll('.login--popup,.sign-up--popup,.reset-password--popup')];
    let returnFocus;
    popups.forEach((popup, index) => {
        popup.setAttribute('role', 'dialog'); popup.setAttribute('aria-modal', 'true');
        const title = popup.querySelector('.title');
        if (title) { title.id = `nt-auth-title-${index}`; popup.setAttribute('aria-labelledby', title.id); }
        popup.querySelectorAll('label').forEach((label, labelIndex) => {
            const field = label.parentElement.querySelector('input:not([type=hidden]),select');
            if (field && !label.htmlFor) { if (!field.id) field.id = `nt-auth-${index}-${labelIndex}`; label.htmlFor = field.id; }
        });
        popup.querySelectorAll('.login--close,.sign-up--close,.reset-password--close').forEach(control => {
            control.setAttribute('role','button'); control.tabIndex = 0;
            control.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); control.click(); } });
        });
        new MutationObserver(() => {
            if (popup.classList.contains('active')) {
                if (!popups.some(other => other !== popup && other.classList.contains('active'))) returnFocus = document.activeElement;
                popup.querySelector('input:not([type=hidden]),button')?.focus();
            } else if (!popups.some(other => other.classList.contains('active'))) returnFocus?.focus();
        }).observe(popup, {attributes:true, attributeFilter:['class']});
        popup.addEventListener('keydown', event => {
            if (event.key === 'Escape') { popup.classList.remove('active'); return; }
            if (event.key !== 'Tab') return;
            const focusables = [...popup.querySelectorAll('input:not([type=hidden]),button,a[href],select,[tabindex="0"]')].filter(e => !e.disabled && e.getClientRects().length);
            const first = focusables[0], last = focusables[focusables.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        });
    });
});
